import script from "./AiSidebarChatComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiSidebarChatComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AiSidebarChatComponent.vue?vue&type=style&index=0&id=938b21f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938b21f8"]])

export default __exports__